import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import type { ReporteCliente } from '../types'

interface ReporteCardProps {
  reporte: ReporteCliente
}

export function ReporteCard({ reporte }: ReporteCardProps) {
  return (
    <Card className="border border-gray-300 dark:border-gray-700">
      <CardHeader className="pb-3">
        <CardTitle className="text-base">{reporte.nombre}</CardTitle>
      </CardHeader>
      <CardContent>
        <iframe
          src={reporte.url}
          className="w-full aspect-video rounded border-0"
          allowFullScreen
          title={reporte.nombre}
        />
      </CardContent>
    </Card>
  )
}
